export const generateGiftSetId = ()=>`gift_set_${Date.now()}_${Math.floor(Math.random() * 100000)}`;
